module.exports = __webpack_public_path__ + "static/media/stackUsingLinkedList.b2cb2aaf.c";